<template>
  <section>
    <BreadcrumbsInline
      :breadcrumbs="breadcrumbs"
      class="hidden-sm-and-down"
    />

    <BreadcrumbsDropdown
      :breadcrumbs="breadcrumbs"
      class="hidden-md-and-up"
    />
  </section>
</template>

<script>
import BreadcrumbsInline from '@/components/Navigation/Header/Breadcrumbs/Inline'
import BreadcrumbsDropdown from '@/components/Navigation/Header/Breadcrumbs/Dropdown'

export default {
  components: {
    BreadcrumbsInline,
    BreadcrumbsDropdown
  },
  props: {
    breadcrumbs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import 'variables';
  @import '~element-ui/lib/theme-chalk/display.css';

  section:first-of-type {
    display: flex;
    flex: 1;
    align-items: center;
  }
</style>
